import swal from 'sweetalert2'
import api from '../../models/truck'
import truckListEditModal from '../../components/modal/truck_edit_modal'
import trucklistAddModal from '../../components/modal/truck_add_modal'

export default {
  name: 'truck',
  components: {
    truckListEditModal,
    trucklistAddModal,
  },
  data() {
    return {
      search_text: '',
      is_active: 1,
      isLoad: false,
      str_data: '',
      modal_type: 0,
      spl_id: '',
      spl_code: '',
      spl_name: '',
      spl_plant_code: '',
      result_data: {},
      modal_data: {
        cdp_id: '',
        spl_id: '',
        cdpl_truck_no: '',
        cdpl_truck_type: '',
        cdpl_shipping_time: '',
        cdpl_shipping_time_h: '',
        cdpl_shipping_time_m: '',
        cdpl_lead_time_day: '',
        cdpl_delivery_time: '',
        cdpl_delivery_time_h: '',
        cdpl_delivery_time_m: '',
        cdpl_delivery_time_end_h: '',
        cdpl_delivery_time_end_m: '',
        cdmp_mon: false,
        cdmp_tue: false,
        cdmp_wed: false,
        cdmp_thu: false,
        cdmp_fri: false,
        cdmp_sat: false,
      },
    }
  },
  methods: {
    backTopage() {
      this.$router.push({
        name: 'Truck',
      })
    },
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    activePage(value) {
      this.active_page = value
      this.search()
    },
    search() {
      this.isLoad = true
      api.getTruckDetail(
        this.$store.state.URLHost,
        this.spl_id,
        this.header,
        (result) => {
          if (result.response === true) {
            this.result_data = result.data
          } else {
            this.alert_msg('warning', 'Pattern', result.message)
          }
          this.isLoad = false
        },
        (error) => {
          this.alert_msg('error', 'Pattern', error.message)
          this.isLoad = false
        }
      )
    },
    getSupplier() {
      api.getSupplier(
        this.$store.state.URLHost,
        this.spl_id,
        this.header,
        (result) => {
          if (result.response === true) {
            this.spl_code = result.data.code
            this.spl_name = result.data.name
            this.spl_plant_code = result.data.plantcode
          } else {
            this.alert_msg('warning', 'Pattern', result.message)
          }
        },
        (error) => {
          this.alert_msg('error', 'Pattern', error.message)
        }
      )
    },
    addTrucklist() {
      this.modal_type = 0
      this.modal_data = {
        cdp_id: '',
        spl_id: this.spl_id,
        spl_name: this.spl_name,
        spl_plant_code: this.spl_plant_code,
        cdpl_truck_no: '',
        cdpl_truck_type: '',
        cdpl_shipping_time: '',
        cdpl_shipping_time_h: '',
        cdpl_shipping_time_m: '',
        cdpl_lead_time_day: '',
        cdpl_delivery_time: '',
        cdpl_delivery_time_h: '',
        cdpl_delivery_time_m: '',
        cdpl_delivery_time_end_h: '',
        cdpl_delivery_time_end_m: '',
        cdmp_mon: false,
        cdmp_tue: false,
        cdmp_wed: false,
        cdmp_thu: false,
        cdmp_fri: false,
        cdmp_sat: false,
      }
      this.ModalBoots('TruckModal').show()
    },
    editTrucklist(obj) {
      this.modal_type = 1
      this.modal_data = obj
      this.ModalBoots('TruckModal').show()
    },
    deleteTrucklist(obj) {
      swal
        .fire({
          title: 'Are you sure?',
          text:
            'Confirm delete : Pattern ' +
            obj.cdp_name +
            ' Truck No.' +
            obj.cdpl_truck_no,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#67757c',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'Cancel',
        })
        .then((result) => {
          if (result.value) {
            api.deleteTruck(
              this.$store.state.URLHost,
              obj.cdpl_id,
              this.header,
              (result) => {
                if (result.response === true) {
                  this.alert_msg('success', 'Successful.', result.message)
                } else {
                  this.alert_msg('error', 'An error occurred.', result.message)
                }
                this.search()
              },
              (error) => {
                this.alert_msg('error', 'An error occurred.', error.message)
                this.search()
              }
            )
          }
        })
    },
    goTruckPattern(obj) {
      this.$router.push({
        name: 'truckpattern',
        params: {
          spl_id: this.spl_id,
        },
      })
    },
  },
  created() {
    this.checkOAuth()
    this.spl_id =
      typeof this.$route.params.spl_id !== 'undefined'
        ? this.$route.params.spl_id
        : 0
  },
  mounted() {
    //  this.spl_id = this.$route.query.id !== undefined ? this.$route.query.id : this.spl_id
    setTimeout(() => {
      if (sessionStorage.token) {
        this.getSupplier()
        setTimeout(() => {
          this.activePage(1)
        }, 300)
      } else {
        setTimeout(() => {
          this.getSupplier()
          setTimeout(() => {
            this.activePage(1)
          }, 300)
        }, 1000)
      }
    }, 1000)
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/truckdetail.js